import {httpRequest} from "@/providers/http";
import {adaptRegistrationRequest, adaptRegistrationResponse} from "./registration.adapter";
import type {
  RegistrationApiPayload,
  RegistrationApiResponse,
  RegistrationRequest,
  RegistrationResult,
} from "./registration.types";

export const registrationService = async (payload: RegistrationRequest): Promise<RegistrationResult> => {
  const body = adaptRegistrationRequest(payload);
  const response = await httpRequest<RegistrationApiResponse, RegistrationApiPayload>({
    method: "POST",
    url: "/register/simplified",
    body,
    auth: false,
  });
  return adaptRegistrationResponse(response);
};
